import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Host,
  HostBinding,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  SkipSelf,
} from '@angular/core';
import { ControlContainer, ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kgr-checkbox-control',
  templateUrl: './checkbox-control.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: CheckboxControlComponent,
      multi: true,
    },
  ],
  imports: [ReactiveFormsModule],
})
export class CheckboxControlComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @HostBinding('class.kgr-checkbox') defaultCssClasses = true;
  @HostBinding('class.is-disabled') disabled!: boolean;
  @HostBinding('class.kgr-checkbox--standalone') get standalone() {
    return !this.label;
  }

  @Input() formControlName?: string;
  @Input() formControl!: UntypedFormControl;
  @Input() @HostBinding('class.kgr-checkbox--inline') inline = false;
  @Input() @HostBinding('class.kgr-checkbox--small') small = false;
  @Input() @HostBinding('class.kgr-checkbox--big') big = false;

  @Input() public label?: string;
  @Input() public required = false;

  public onTouched: any;
  private valueChangesSubscription?: Subscription;

  constructor(
    @Optional()
    @Host()
    @SkipSelf()
    private controlContainer: ControlContainer,
    private injector: Injector,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    if (!this.formControl) {
      if (this.formControlName) {
        if (this.controlContainer && this.controlContainer.control) {
          const formControl = this.controlContainer.control.get(this.formControlName);
          if (formControl && formControl instanceof UntypedFormControl) {
            this.formControl = formControl;
          } else {
            console.warn(`Missing FormControl with name ${this.formControlName}`);
          }
        } else {
          console.warn("Can't find parent FormGroup directive");
        }
      }
    }

    if (this.formControl) {
      this.valueChangesSubscription = this.formControl.valueChanges.subscribe((_value) => {
        this.cd.markForCheck();
      });
    } else {
      console.error('Could not read formControl');
    }
  }

  ngOnDestroy() {
    this.valueChangesSubscription?.unsubscribe();
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  registerOnChange(_fn: any): void {} // logic is delegated to form control directive used in template
  writeValue(_value: any): void {} // logic is delegated to form control directive used in template
  setDisabledState(value: boolean): void {
    this.disabled = value;
    this.cd.detectChanges();
  }
}
